import CategoryTile from "../components/category-tile";
import { LISTING_API } from "@/lib/constants";
import { TCategoryData } from "@/services/category";
import { useQuery } from "@tanstack/react-query";
import { capitalCase } from "change-case";

async function getCategoriesData() {
	const url = new URL(`${LISTING_API}`);
	const res = await fetch(url);

	if (!res.ok) {
		const { message } = await res.json();
		throw new Error(message);
	}

	const { data } = (await res.json()) as { data: TCategoryData[] };

	return data;
}

const Categories = () => {
	const { data: categories = [] } = useQuery({
		queryKey: ["categories"],
		queryFn: getCategoriesData,
	});

	return (
		<div className="mx-auto mt-8 flex w-11/12 max-w-3xl flex-wrap items-center justify-center gap-6 sm:mt-12 sm:gap-8 lg:w-full">
			{categories.map((category: TCategoryData) => (
				<CategoryTile
					key={category.id}
					labelText={capitalCase(category.status)}
					title={category.title}
					labelTextClassName={category.status === "new" ? "bg-green-500" : "bg-red-500"}
					href={`/categories/${category.slug}`}
					icon={category.logoUrl}
					status={category.status}
				/>
			))}
		</div>
	);
};

export default Categories;
